import { object, shape } from 'prop-types';
import React from 'react';
import { CheckboxGroup } from '@eika/checkbox';
import { SkjemaSporsmal } from '../../ahv-schema';
import { getIsDisabled } from '../../form-util';
import { getPreselected, isRequiredQuestion, isRequiredWhenSelected } from '../helper/component-helper';
import connect from '../helper/connect';
import ErrorMessage from '../errormessage';
import text from '../../constants/text';
import { KUN_LESING } from '../../constants/general';

function CheckboxQuestionType(props) {
    const { question, context } = props;
    const { muligeSvar, instruks, definisjon, utfyllingsregel } = question;
    const answers = context.getValue(definisjon);

    const hasError = (newAnswers) => {
        return newAnswers.length === 0;
    };

    const isChecked = (id) => {
        return context.getValue(definisjon).includes(id);
    };

    const onChange = (id) => {
        const newAnswers = [...answers];

        const existingIndex = newAnswers.indexOf(id);

        if (existingIndex >= 0) {
            newAnswers.splice(existingIndex, 1);
        } else {
            newAnswers.push(id);
        }

        context.onChange(definisjon, { value: newAnswers, error: hasError(newAnswers) });
    };

    const preselected = getPreselected(question);
    const hasInvalidValue = context.hasError(definisjon);

    const createOptionsList = (muligeSvar) => {
        const optionsList = [];
        muligeSvar.forEach((svar) => {
            const { svarId, tekst } = svar;
            const checked = isChecked(svarId);
            const name = `checkbox_${svarId}`;
            optionsList.push({
                onChange: () => onChange(svarId),
                checked,
                label: tekst,
                id: name,
                onBlur: () => context.updateValidation(definisjon, true, hasError(answers)),
                disabled: getIsDisabled(utfyllingsregel.regel, preselected, context.getRolle()),
            });
        });
        return optionsList;
    };

    const getQuestionText = () => {
        // Support brittle sporsmalstekst with markup
        if (
            question.sporsmalstekst != null &&
            (question.formaterHTML || (question.config && question.config.formaterHTML))
        ) {
            /* eslint-disable react/no-danger */
            return (
                <span
                    className="skjema-input-question"
                    dangerouslySetInnerHTML={{
                        __html: question.sporsmalstekst,
                    }}
                />
            );
        }

        if (question.utfyllingsregel.regel === KUN_LESING) {
            return question.sporsmalstekst;
        }
        return isRequiredQuestion(question.utfyllingsregel) ||
            (isRequiredWhenSelected(question) && getPreselected(question))
            ? question.sporsmalstekst
            : `${question.sporsmalstekst} ${text.TEXT_OPTIONAL}`;
    };

    return (
        <div className={`skjema-input-field skjema-radio ${hasInvalidValue && 'has-error error'}`}>
            <div className="checkbox">
                <CheckboxGroup
                    label={getQuestionText()}
                    className="checkbox-input"
                    options={createOptionsList(muligeSvar)}
                />
            </div>
            {hasInvalidValue && <ErrorMessage text={instruks} />}
        </div>
    );
}

CheckboxQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(CheckboxQuestionType));
